export default {
    computed: {
        // loadong colors form env varibale
        iconStyles() {
            return {
                color: process.env.VUE_APP_ICON_COLOR,
            };
        },
        bgStyles(){
            return {
                background: process.env.VUE_APP_ICON_COLOR,
            }
        }
    },
}